import React from "react";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex justify-center items-center">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-transparent border-t-gray-600 border-b-gray-600 opacity-50"></div>
    </div>
  );
};

export default LoadingSpinner;
